import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  // { 
  //   _id: uuid(),
  //   img : 'https://www.trackandtrail.in/sites/default/files/styles/listing_image/public/romer3_0.png?itok=tePICCz7',
  //   desc : 'BSA Roamer 20T Magic Blue',
  //   price: '4,149',
  //   rating: '4.2',
  //   brand:'BSA',
  //   type: 'kids',
  //   gender:'male',
  //   quantity: 1,
  //   isAddedInWishlist: false,
  //   isItemAddedInCart: false,
  // },
  // {
  //   _id: uuid(),
  //   img : 'https://www.trackandtrail.in/sites/default/files/styles/banner/public/1_11.png?itok=b9btz3JW',
  //   desc : 'Roadeo STR1 29T Green',
  //   price: '14,500',
  //   rating: '4',
  //   brand:'roadeo',
  //   type: 'city',
  //   gender:'male',
  //   quantity: 1,
  //   isAddedInWishlist: false,
  //   isItemAddedInCart: false,
  // },
  // {
  //   _id: uuid(),
  //   img : 'https://www.trackandtrail.in/sites/default/files/styles/banner/public/str2-brown.png?itok=2v7ZLnlq',
  //   desc : 'Roadeo STR2 29T Brown',
  //   price: '14,400',
  //   rating: '4.8',
  //   brand:'roadeo',
  //   type: 'city',
  //   gender:'male',
  //   quantity: 1,
  //   isAddedInWishlist: false,
  //   isItemAddedInCart: false,
  // },
  {
    _id: uuid(),
    img : 'https://www.trackandtrail.in/sites/default/files/styles/banner/public/stx_0.png?itok=YzZp-QgL',
    desc : 'Roadeo STX1 26T Sun Flower Yellow',
    price: '13235',
    rating: '4.6',
    brand:'roadeo',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : '	https://www.trackandtrail.in/sites/default/files/warcy-red.png',
    desc : 'Roadeo Warcry 27.5T Neon Red with Black',
    price: '15850',
    rating: '3',
    brand:'roadeo',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false, 
  },
  {
    _id: uuid(),
    img : 'https://www.trackandtrail.in/sites/default/files/madrock-orange_0_2.png',
    desc : 'Montra Madrock Medium 27.5T Orange',
    price: '21400',
    rating: '4.2',
    brand:'montra',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://www.trackandtrail.in/sites/default/files/styles/banner/public/4_2.png?itok=gUgxQQ5G',
    desc : 'BSA Ladybird 26T Hot Pink',
    price: '9055',
    rating: '4.6',
    brand:'BSA Ladybird',
    type: 'city',
    gender:'female',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://www.trackandtrail.in/sites/default/files/montra_black_with_orange_0_0.png',
    desc : 'Montra City Unplugged Medium Neon Orange',
    price: '19500',
    rating: '2.5',
    brand:'montra',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/229825d08227bad666eecc78c6bddbfe',
    desc : 'MACH CITY 26T',
    price: '20690',
    rating: '2.6',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/76d594c0a93df81ebd347c985b51e74c',
    desc : 'MACH CITY 26T',
    price: '20500',
    rating: '2',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false, 
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/309a832a37589b5823c2b9deb3b62309',
    desc : 'Hercules 26T',
    price: '22500',
    rating: '3',
    brand:'hercules',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false, 
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/db8b2669960e2bdf1080609b03f87726',
    desc : 'MACH CITY 26T',
    price: '25500',
    rating: '3.4',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/9248f8b6424c08922a38dcfd594f7e4b',
    desc : 'MACH CITY 26T',
    price: '15500',
    rating: '2.8',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/721d24d2979fedcd3b64e6998dbc10a6',
    desc : 'MACH CITY 26T',
    price: '18500',
    rating: '2.8',
    brand:'mach city',
    type: 'kids',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/17f4bd65a56bc18c68a26aa1e6afccb1',
    desc : 'MACH CITY 29T',
    price: '16149',
    rating: '5',
    brand:'mach city',
    type: 'mountain',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false, 
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/623aa20794e5e34802fd2bf628701305',
    desc : 'MACH CITY 27.5T',
    price: '21789',
    rating: '3.4',
    brand:'mach city',
    type: 'kids',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/8fbac53f1712d605d5c5449b1ed1c7d7',
    desc : 'MACH CITY 29T',
    price: '22499',
    rating: '4.2',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/d91eec3ccc05fe917e2562f0943e44fe',
    desc : 'Hercules 24T',
    price: '15524',
    rating: '4.8',
    brand:'hercules',
    type: 'kids',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/3efee3e00b4ba828c4419e0118970740',
    desc : 'Hercules 27T',
    price: '13899',
    rating: '2.2',
    brand:'hercules',
    type: 'kids',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/5c859811c21d18a6fd9403fb4320b91e',
    desc : 'MACH CITY 29T',
    price: '22499',
    rating: '1.5',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
  {
    _id: uuid(),
    img : 'https://d2f9uwgpmber13.cloudfront.net/public/uploads/mobile/2e13a3b5896b889c548d96d940dbec57',
    desc : 'MACH CITY 25T',
    price: '23219',
    rating: '4.8',
    brand:'mach city',
    type: 'city',
    gender:'male',
    quantity: 1,
    isAddedInWishlist: false,
    isItemAddedInCart: false,
  },
];
